<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-row justify="center">
                <v-col cols="3">
                    <v-select rounded :items="aylist" label="Academic Year" @change="getFeesInstallmentAcademicYear()" item-text="ay" item-value="id" outlined dense v-model="ay"></v-select>
                </v-col>
                <v-col cols="3">
                    <v-select rounded :items="standard_list" label="Standard List" item-text="standard" item-value="id" @click="new_admission_flag == null" outlined dense v-model="standard" @change="checkFlag()"></v-select>
                </v-col>
                <v-col cols="3">
                    <v-select rounded :items="quota_list" label="Quota List" item-text="name" item-value="id" outlined dense v-model="quota"></v-select>
                </v-col>
                <v-col cols="3" v-if="this.installment_list.length > 0">
                    <v-select rounded :items="installment_list" label="Installment List" item-text="name" item-value="id" outlined dense v-model="installment"></v-select>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="new_admission_flag">
                <v-checkbox v-model="add_new_admision_fee_structure" label="Fee Structure For New Addmission"></v-checkbox>
            </v-row>
            <v-row justify="center">
                <v-col cols="3"> </v-col>
                <v-col cols="5">
                    <v-btn class="mb-2 button" small @click="proceed()" :loading="loader">Proceed</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="this.showcard">
            <v-row justify="center">
                 <v-col cols="12" sm="3" md="3">
                    <p class="padding-bot"><b>Late Fee Charge Start Date</b></p>
                    <input type="date" class="padding-bot" v-model="fixed_fine_start_date" />
                </v-col> 
                 <v-col cols="12" sm="3" md="3">
                    <p class="padding-bot"><b>Late Fee Charge End Date</b></p>
                    <input type="date" class="padding-bot" v-model="fixed_fine_end_date" />
                </v-col> 
                <v-col cols="12" sm="3" md="3">
                    <p class="padding-bot"><b>Late Fee Charge Between Start Date And End Date</b></p>
                    <v-text-field class="padding-bot" rounded outlined dense v-model="fine_in_rs"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p class="padding-bot"><b>Late Fee Charge Onwards End Date</b></p>
                    <v-text-field class="padding-bot" rounded outlined dense v-model="variable_fine_in_rs"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <p class="padding-bot"><b>Select Discount Type</b></p>
                    <v-select rounded :items="discount_type_list" label="Discount Type" item-text="name" item-value="id"
                        outlined dense v-model="discount_type"  :append-icon="discount_type ? 'mdi-close' : 'mdi-menu-down'"
                        @click:append="handleAppendClick">
                    </v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="discount_type">
                    <p class="padding-bot"><b>Discount Date</b></p>
                    <input type="date" class="padding-bot" v-model="discount_date" />
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="discount_type">
                        <p class="padding-bot"><b>{{ isPercentageDiscount ? 'Discount Percentage' : 'Discount Amount'}}</b></p>
                        <v-text-field v-if="isPercentageDiscount" v-model="discount_amount" type="number" min="1"
                            max="100" suffix="%" rounded outlined dense>
                        </v-text-field>

                        <v-text-field v-else v-model="discount_amount" type="number" min="0" rounded outlined dense>
                        </v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-btn v-if="fixed_fine_start_date && fixed_fine_end_date" class=" button" @click="save()" :loading="loader">Save</v-btn>
            </v-row>
            <v-row justify="center">
                <v-col v-if="fixed_fine_start_date != '' && fixed_fine_end_date!=''" cols="12" sm="4" md="4" class="pt-1 mt-4">
                    <v-select multiple rounded :items="standard_list" label="Copy due date to standard" placeholder="Copy due date to standard" item-text="standard" item-value="id" outlined dense v-model="standard_copy_due_date"></v-select>
                </v-col>
                 <v-col cols="12" sm="3" md="3">
                <v-btn v-if="standard_copy_due_date != ''" class="mb-2 button" :loading="loader3" small @click="copyDueDate">Copy Due Date</v-btn>
                 </v-col>
            </v-row>
        </v-card>

        <v-card class="box" v-if="this.showcomponent && components.length > 0">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title> Fees Components</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-col cols="12" sm="12" md="12">
                <div id="my-table-id">
                <v-simple-table class="elevation-1 mytable" dense v-if="components.length > 0" id="mytable1">
                    <template>
                        <thead color="#ffffcc">
                            <tr>
                                <th class="text-left">Sr. No.</th>
                                <th class="text-left">Fees Components</th>
                                <th class="text-left">Amount In Rs.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in components" :key="item.id">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.name }}</td>
                                <td>
                                    <input type="hidden" name="components_id" value="item.id" />
                                    <!-- <v-text-field type="number" value="0" rounded class="padding-bot ml-2 pt-2" outlined dense v-model="item.amount" @change="addToSum(item.amount,item.id)"></v-text-field> -->
                                    <v-text-field type="number" value="0" rounded class="padding-bot ml-2 pt-2" outlined dense v-model="item.amount"></v-text-field>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </div>
            </v-col>
            <v-row justify="center" v-if="total_component_value != 0">
                <v-col cols="3"> </v-col>
                <v-col cols="5">
                    <p class="padding-bot">
                        <b>Total - {{ this.total_component_value }}</b>
                    </p>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="3"> </v-col>
                <v-col cols="5">
                    <v-btn class="mb-2 button" :disabled="save_disable || isapproved" small @click="saveDetails(components)" :loading="loader">Save</v-btn>
                    <v-btn v-if="this.comfirm_btn" :disabled="isapproved" class="mb-2 button" small @click="saveComfirmDetails()" :loading="ap_loader">Approve</v-btn>
                    <v-btn class="mb-2 button" :disabled="!isapproved" @click="dialog_unapprove = true" small>Unapprove</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="this.show_copy_div">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title> Copy Fees Structure</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="3"> </v-col>
                <v-col cols="3">
                    <v-select rounded :items="standard_list" label="Standard List" item-text="standard" item-value="id" outlined dense v-model="standard_copy"></v-select>
                </v-col>
                <v-col cols="5">
                    <v-btn class="mb-2 button" small @click="copy_feesStructure()" :loading="loader">Copy</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="output_load" width="800">
            <v-card>
                <v-col cols="12" sm="12" md="12" v-if="fail_list != ''">
                    <v-card class="box">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Failed Data</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <!-- <download-excel class="ma-2 no-display" color="primary" dark :data="fail_list" :fields="xls_header1" worksheet="Failed Data" name="Failed_Data.xls">
                            <v-btn class="ma-2 no-display" tile outlined color="success">
                                <v-icon left>mdi-file-excel</v-icon> Excel
                                <v-icon right>mdi-download</v-icon>
                            </v-btn>
                        </download-excel> -->
                        <v-btn  class="ma-2 no-display" rounded  color="success"   outlined  @click="fnExcelReport('my-table-id', 'FeeStructureInstallmentVVPReport')"  :loading="loader"   ><v-icon color="success">mdi-export</v-icon>Export</v-btn>

                        <template>
                            <v-data-table dense :headers="headers" :items="fail_list" sort-by class="elevation-1 mytable" :search="search"></v-data-table>
                        </template>
                        <center>
                            <v-btn class="mb-2 button" small @click="output_load = false">Close</v-btn>
                        </center>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_unapprove" width="500">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense justify="center">
                            <strong>Are sure want delete !!!!</strong>
                        </v-row>
                    </v-card>
                </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="unapproveFeeStructure()">Yes</v-btn>
                    <v-btn class="button" @click="dialog_unapprove = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dialog_unapprove: false,
            standard_copy: "",
            showcomponent: false,
            fine_in_rs: 0,
            variable_fine_in_rs: 0,
            relaxation_days: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: false,
            search: "",
            aylist: [],
            ay: "",
            standard_list: [],
            standard: "",
            standard_copy_due_date: [],
            quota_list: [],
            quota: "",
            installment_list: [],
            installment: "",
            showcard: false,
            prelim_date: "",
            fixed_fine_start_date:"",
            fixed_fine_end_date:"",
            components: [],
            components_value: [],
            components_id: [],
            total_component_value: 0,
            fees_structure_installment_details: [],
            comfirm_btn: false,
            isapproved: false,
            updated_comp_value: [],
            save_disable: false,
            save_disable_1: false,
            show_copy_div: false,
            feesStructureInstallment: "",
            ap_loader: false,
            loader3: false,
            fail_list: [],
            output_load: false,
            new_admission_flag: null,
            add_new_admision_fee_structure: false,
            discount_type: "",
            discount_amount: "",
            discount_date: "",
            discount_type_list: [],
            xls_header1: {
                Standard: "standard",
                Reason: "reason",
            },
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Standard",
                    align: "left",
                    sortable: false,
                    value: "standard",
                },
                {
                    text: "Reason",
                    align: "left",
                    sortable: false,
                    value: "reason",
                },
            ],
        }),
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            unapproveFeeStructure() {
                const formData = {
                    ay: this.ay,
                    standard: this.standard,
                    quota: this.quota,
                    installment: this.installment,
                    add_new_admision_fee_structure: this.add_new_admision_fee_structure,
                };
                axios
                    .post("/FeesStructureInstallment/unapproveFeeStructure", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Fee structure updated Successfully..."); // show snackbar on success
                            this.proceed();
                            this.dialog_unapprove = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.dialog_unapprove = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.dialog_unapprove = false;
                    })
                    .finally(() => {});
            },
            checkFlag() {
                // console.log(this.standard);
                let std = this.standard_list.find((element) => element.id == this.standard);
                console.log("tag", std);
                this.new_admission_flag = std.is_new_admission_fee_applicable_logic;
            },
            clearData() {
                (this.installment_list = []),
                    (this.installment = ""),
                    (this.showcard = false),
                    (this.prelim_date = ""),
                    (this.fixed_fine_start_date = ""),
                    (this.fixed_fine_end_date = ""),
                    (this.components = []),
                    (this.components_value = []),
                    (this.components_id = []),
                    (this.comfirm_btn = false),
                    (this.isapproved = false),
                    (this.standard = ""),
                    // (this.ay = ""),
                    (this.quota = ""),
                    (this.fine_in_rs = 0),
                    (this.variable_fine_in_rs = 0),
                    (this.relaxation_days = "");
                this.show_copy_div = false;
                this.standard_copy = "";
                this.total_component_value = 0;
                (this.new_admission_flag = null), (this.add_new_admision_fee_structure = false);
            },
            copyDueDate() {
                this.loader3 = true;
                const formData = {
                    feesStructureInstallment: this.feesStructureInstallment,
                    standard: this.standard_copy_due_date,
                };
                axios
                    .post("FeesStructureInstallment/copyDueDate", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.fail_list = res.data.fail_list;
                            if (this.fail_list != "") {
                                this.output_load = true;
                            }
                            this.showSnackbar("#4CAF50", "Due Date Copied Successfully..");
                            this.clearData();
                            this.loader3 = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader3 = false;
                    })
                    .finally(() => {
                        //close loader
                        this.loader3 = false;
                    });
            },
            copy_feesStructure() {
                this.loader = true;
                const formData = {
                    feesStructureInstallment: this.feesStructureInstallment,
                    standard: this.standard_copy,
                };
                axios
                    .post("FeesStructureInstallment/copyFeesStructure", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Fees Structure Copied Successfully..");
                            this.clearData();
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                    });
            },
            saveComfirmDetails() {
                this.ap_loader = true;
                const formData = {
                    ay: this.ay,
                    standard: this.standard,
                    quota: this.quota,
                    installment: this.installment,
                    add_new_admision_fee_structure: this.add_new_admision_fee_structure,
                };
                axios
                    .post("FeesStructureInstallment/saveComfirmDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Fee Structure Approved Successfully.");
                            this.showcomponent = false;
                            this.showcard = false;
                            this.save_disable = true;
                            this.clearData();
                            this.onLoad();
                            this.isapproved = true;
                            this.onLoad();
                            this.ap_loader = false;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.ap_loader = false;
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        this.save_disable = false;
                        this.ap_loader = false;
                        //alert("done")
                    });
            },
            saveDetails(components) {
                this.loader = true;
                let list = [];
                for (var i = 0; i < components.length; i++) {
                    this.components_id.push(components[i].id);
                    this.components_value.push(components[i].amount);
                }

                const formData = {
                    ay: this.ay,
                    standard: this.standard,
                    quota: this.quota,
                    installment: this.installment,
                    //components_value: list,
                    components_value: this.components_value,
                    components_id: this.components_id,
                    add_new_admision_fee_structure: this.add_new_admision_fee_structure,
                };
                axios
                    .post("FeesStructureInstallment/saveDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Saved Successfully..");
                            this.comfirm_btn = true;
                            this.loader = false;
                            this.total_component_value = res.data.total_component_value;
                            this.proceed();
                            // this.save_disable=true
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                        (this.components_value = []), (this.components_id = []);
                    });
            },
            addTotal() {
                this.total_component_value = 0;
                for (var i = 0; i < this.components_value.length; i++) {
                    this.total_component_value += parseFloat(this.components_value[i]);
                }
                return this.total_component_value;
            },
            addToSum(item, id) {
                this.components_id.push(id);
                this.components_value.push(item);
                return this.components_id, this.updated_comp_value;
            },
            ExportToExcel1(mytblId) {
                var htmltable = document.getElementById("mytable1");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },
            save() {
                if (this.ay == "" || this.standard == "" || this.quota == "" || this.installment == "") {
                    this.showSnackbar("#b71c1c", "Please Select Above Fields");
                    return;
                }
                if (this.fixed_fine_start_date > this.fixed_fine_end_date) {
                    this.showSnackbar("#b71c1c", "Please Select Late Fee Charge End Date Greater Than Late Fee Charge Start Date...");
                    return;
                }
                this.loader = true;
                if (this.discount_type) {
                    const amount = Number(this.discount_amount);
                    if (!this.discount_amount || this.discount_amount === "0" || !this.discount_date) {
                        this.showSnackbar("#b71c1c", "Enter valid Discount Date and Discount Amount");
                        this.loader = false
                        return
                    }

                    if(!this.isPercentageDiscount){
                        if (amount <= 0) {
                            this.showSnackbar("#b71c1c", "Discount amount must be greater than 0");
                            this.loader = false;
                            return;
                        }
                    }

                    if (this.isPercentageDiscount) {
                        if (amount < 1 || amount > 100) {
                            this.showSnackbar("#b71c1c", "Discount Percentage must be between 1 and 100");
                            this.loader = false;
                            return;
                        }
                    }
                }
                
                const formData = {
                    ay: this.ay,
                    standard: this.standard,
                    quota: this.quota,
                    installment: this.installment,
                    prelim_date: this.prelim_date,
                    due_date: this.due_date,
                    fixed_fine_start_date:this.fixed_fine_start_date,
                    fixed_fine_end_date:this.fixed_fine_end_date,
                    fine_in_rs: this.fine_in_rs,
                    variable_fine_in_rs: this.variable_fine_in_rs,
                    relaxation_days: this.relaxation_days,
                    add_new_admision_fee_structure: this.add_new_admision_fee_structure,
                    discount_type: this.discount_type,
                    discount_date: this.discount_date,
                    discount_amount: this.discount_amount
                };
                axios
                    .post("FeesStructureInstallment/save", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Saved Successfully..");
                            this.components = res.data.components;
                            this.showcomponent = true;
                            this.loader = false;
                            //  this.save_disable_1 = true;
                            this.show_copy_div = true;
                            this.proceed();
                        } else {
                            this.components = res.data.components;
                            this.showcomponent = true;
                            this.loader = false;
                            // this.save_disable_1 = true;
                            this.proceed();
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            proceed() {
                if (this.ay == "" || this.standard == "" || this.quota == "" || this.installment == "") {
                    this.showSnackbar("#b71c1c", "Please Select Above Fields");
                    return;
                }
                const formData = {
                    ay: this.ay,
                    standard: this.standard,
                    quota: this.quota,
                    installment: this.installment,
                    add_new_admision_fee_structure: this.add_new_admision_fee_structure,
                };
                axios
                    .post("FeesStructureInstallment/getInstallmentDetails", formData)
                    .then((res) => {
                        (this.showcard = false), (this.showcomponent = false);
                        if (res.data.flag == "YES") {
                            if (res.data.isPresent == false) {
                                //  alert("false")
                                this.showcomponent = true;
                                this.loader = false;
                                this.save_disable_1 = false;
                                (this.prelim_date = ""), (this.due_date = ""), (this.fine_in_rs = 0), (this.relaxation_days = ""), (this.components = ""), (this.showcard = false);
                                (this.total_component_value = ""), (this.fees_structure_installment_details = ""), (this.isapproved = false);
                                this.fixed_fine_start_date = ""
                                this.fixed_fine_end_date = ""
                                this.variable_fine_in_rs = 0
                                this.discount_amount = 0
                                this.discount_type = ""
                                this.discount_date = ""
                            }
                            if (res.data.fees_structure_installment_details) {
                                this.relaxation_days = res.data.fees_structure_installment_details[0].relaxation_days;
                                this.fine_in_rs = res.data.fees_structure_installment_details[0].fine;
                                this.variable_fine_in_rs = res.data.fees_structure_installment_details[0].variable_fine;
                                this.fixed_fine_start_date = res.data.fees_structure_installment_details[0].fixed_fine_start_date;
                                this.fixed_fine_end_date = res.data.fees_structure_installment_details[0].fixed_fine_end_date;
                                this.isapproved = res.data.fees_structure_installment_details[0].isapproved;
                                this.discount_type = res.data.fees_structure_installment_details[0].discount_type || null;
                                this.discount_date = res.data.fees_structure_installment_details[0].discount_date || "";
                                this.discount_amount = res.data.fees_structure_installment_details[0].discount_amount || 0;
                                if (res.data.fees_structure_installment_details[0].components.length > 0) {
                                    //alert("iff-111")
                                    this.components = res.data.fees_structure_installment_details[0].components;
                                }
                                this.fees_structure_installment_details = res.data.fees_structure_installment_details;
                                if (res.data.isPresent == true) {
                                    this.showcard = true;
                                    this.showcomponent = true;
                                    this.total_component_value = res.data.fees_structure_installment_details[0].total;
                                    this.comfirm_btn = true;
                                    this.loader = false;
                                    this.save_disable_1 = true;
                                    (this.show_copy_div = true), (this.feesStructureInstallment = res.data.feesStructureInstallment);
                                }
                            } else {
                                this.showcard = true;
                                this.loader = false;
                                //this.showcomponent=true;
                            }
                        } else {
                            this.showcard = true;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
                //    this.showcard=true
                return;
            },
            getFeesInstallmentAcademicYear() {
                (this.installment_list = []), this.clearData();
                //  this.onLoad();
                const formData = {
                    ay: this.ay,
                };
                axios
                    .post("FeesStructureInstallment/getFeesInstallmentAcademicYear", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            if (res.data.installment_list.length <= 0) {
                                this.showSnackbar("#b71c1c", "No Installments Available");
                                return;
                            }
                            this.installment_list = res.data.installment_list;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onLoad() {
                axios
                    .get("FeesStructureInstallment/getData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.aylist = res.data.aylist;
                            this.standard_list = res.data.standard_list;
                            this.quota_list = res.data.quota_list;
                            this.fine_in_rs = 0;
                            this.variable_fine_in_rs = 0;
                            this.ay = res.data.curreny_ay;
                            if (res.data.installment_list.length <= 0) {
                                this.showSnackbar("#b71c1c", "No Installments Available For Academic Year..");
                                return;
                            }
                            this.installment_list = res.data.installment_list;
                            return;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        }else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            getDiscountTypes() {
                axios.post("FeesStructureInstallment/getDiscountTypes")
                    .then((res) => {
                        if (res.data.code === "SUCCESS") {
                            this.discount_type_list = res.data.discount_type_list
                        }
                    }).catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            handleAppendClick () {
                if (this.discount_type) {
                this.discount_type = null
                this.discount_amount = null
                this.discount_date = null
                }
            },
        },
        mounted() {
            this.onLoad();
            this.getDiscountTypes();
        },
        watch: {},
        computed: {
            isPercentageDiscount() {
                const dt = this.discount_type_list.find(
                    d => d.id === this.discount_type
                );
                return dt && dt.name.toLowerCase() === "percentage";
            }
        }
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
</style>
